import {mock} from './index';

export default {
  getUserAssetAssignList: () => ('/admin/user/asset/assignedList'),
  getUserAssetList: () => mock('/admin/user/asset/list'),
  assignAssetForUser: () => mock('/admin/user/asset/assign'),
  removeAssetFromUser: () => mock('/admin/user/asset/remove'),
  getUserGroupAssetAssignList: () => mock('/admin/userGroup/asset/assignedList'),
  getUserGroupAssetList: () => mock('/admin/userGroup/asset/list'),
  assignAssetForUserGroup: () => mock('/admin/userGroup/asset/assign'),
  removeAssetFromUserGroup: () => mock('/admin/userGroup/asset/remove')
};
